<template>
  <li class="flex items-center">
    <span class="label caption-regular text-secondary-secondary flex items-center gap-050">
      <span>{{ `${label}:` }}</span>
    </span>

    <div class="w-full caption-bold">
      <slot />
    </div>
  </li>
</template>

<script lang="ts" setup>
type ScratchcardListItemProps = { label: string }

defineProps<ScratchcardListItemProps>()
</script>

<style lang="scss" scoped>
.label {
  min-width: 5rem;
}
</style>
